export const translations = {
  criarRTV: {
	"pt": "Criar RTV",
	"en": "Create RTV",
	"de": "RTV erstellen",
	"es": "Crear RTV",
  },
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
};
